import Cookies from 'js-cookie'

export const getIsAuthenticated = () => Cookies.get('authenticated')
